// extracted by mini-css-extract-plugin
module.exports = {"section":"K5_section__hOnH_"};